import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ProductCategory } from 'src/app/assabil-kernel/models/entities/control-tables/product-category-entity';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';


@Component({
    selector: 'product-category-list',
    templateUrl: './product-category-list.component.html',
    styleUrls: ['./product-category-list.component.scss']
})


export class ProductCategoryListComponent extends BasePage2<ProductCategory> {

    productCategories   : ProductCategory[] = [];
    code                : string;
    name                : string;

    constructor(
        protected toastr                : ToastrService,
        protected controlTablesService  : ControlTablesService,
        protected router                : Router,
        protected baseService           : BaseService,
        protected leanUtilsService      : LeanUtilsService, 
        protected location              : Location) {
         super(toastr, router, baseService, leanUtilsService, location);

         this.entityName = 'productCategory';
    }

//----------------------------------------------------------------------
ngAfterViewInit(): void {
    super.ngAfterViewInit();
      this.setChildFields();
  }
//----------------------------------------------------------------------

//----------------------------------------------------------------------
setChildFields(){
    this.baseService.fieldsGet('productCategoryType').then(result => {
          this.childFields = result.listFields;
          this.readOnly    = result.readOnly;
    }) 
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
 getRows(): ProductCategory[] {
    return this.productCategories;
 }
//----------------------------------------------------------------------


//----------------------------------------------------------------------
 new(){
    let productCategory : ProductCategory = new ProductCategory();
    productCategory.inserted = true;
    productCategory.edit = true;
    this.selectedRow = productCategory;
}  
//----------------------------------------------------------------------


//----------------------------------------------------------------------
loadData() {
    let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
        request.strArg1 = this.code;
        request.blnArg1 = false;

        this.controlTablesService.getList(this.entityName, request).then(result => {
            this.productCategories = result;
        })
    }
//----------------------------------------------------------------------


//----------------------------------------------------------------------
selectRow(productCategory : ProductCategory){
    let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
    request.strArg1 = productCategory.productCategoryCode;
    this.controlTablesService.getSingle(this.entityName, request).then(result => {
        this.selectedRow = result;
    })
  }
//----------------------------------------------------------------------

}
